import { createAsyncThunk } from '@reduxjs/toolkit'

import * as API from '../../api'

export const getRecentRecords = createAsyncThunk('home/getRecentRecords', async () => {
  const response = await API.getRecentRecords()
  return response.data
})

export const getTopicInfos = createAsyncThunk('home/getTopicInfo', async () => {
  const response = await API.getTopicInfos()
  return response.data
})
